module.exports = __webpack_public_path__ + "media/images/flags/1x1/twn-731caa835d32c6a26efd843066659657.svg";